/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

// eslint-disable-next-line import/prefer-default-export
export class PromiseDebouncer {
    constructor() {
        this.requests = new Map();
    }

    debounce(key, promiseFactory) {
        const keyForComparison = JSON.stringify(key);
        if (!this.requests.has(keyForComparison)) {
            const promise = promiseFactory();
            // Clean up after the promise.
            promise.finally(() => {
                this.requests.delete(keyForComparison);
            });
            this.requests.set(keyForComparison, promise);
        }
        return this.requests.get(keyForComparison);
    }

    get(key) {
        return this.requests.get(JSON.stringify(key));
    }
}
